const doc = [({"da":({"js":({"admin":({"contacts":({"edit":({"supplier_content":({"supplier_information":"Leverandør information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;